import { doctorWhoStoryTitleLookup } from '../../constants/doctorWhoStoryTitleLookup'
import { doctorWhoValidGuesses } from '../../constants/doctorWhoValidGuesses'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  word: string
}

export const QuoteModal = ({ isOpen, handleClose, word }: Props) => {
  if (!word || !doctorWhoValidGuesses[word]) return null
  return (
    <>
      <BaseModal
        title={word.toUpperCase()}
        isOpen={isOpen}
        handleClose={handleClose}
      >
        <p className="text-sm text-gray-500 dark:text-gray-300">
          {word.toUpperCase()} has been said{' '}
          <b>
            {doctorWhoValidGuesses[word].count > 1
              ? `${doctorWhoValidGuesses[word].count} times`
              : 'once'}
          </b>{' '}
          in <i>Doctor Who</i>.
        </p>
        <p className="mt-6 text-sm text-gray-500 dark:text-gray-300">
          It was first said by{' '}
          <b>
            {doctorWhoValidGuesses[word].firstSaidBy ?? 'UNKNOWN CHARACTER'}
          </b>{' '}
          in{' '}
          <b>
            {doctorWhoStoryTitleLookup[
              doctorWhoValidGuesses[word].firstSaidSeasonIndex
            ][doctorWhoValidGuesses[word].firstSaidStoryIndex]?.toUpperCase() ??
              'UNKNOWN STORY'}
          </b>
          :
        </p>
        <p className="mt-2 italic text-sm text-gray-500 dark:text-gray-300">
          "{doctorWhoValidGuesses[word].firstSaidQuote}"
        </p>
      </BaseModal>
    </>
  )
}
